import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedManagerRoute = ({ children }) => {
  const { loading, loaded, isAuthenticated, user } = useSelector(
    (state) => state.user,
  );
  const location = useLocation();

  if (!loaded || loading) {
    return null; // or a spinner component
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (user?.role !== "manager" && user?.role !== "admin") {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedManagerRoute;
